// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'
// import AuthService from '@/services/auth'

const state = {
  // user: Utils.parseJSON(Storage.get('user')),
  /* whether sound track loaded */
  isPlaying: false,
  isPaused: false,
  isShuffle: false,
  list: [],
  tracks: [],
  listIndex: -1,
  trackIndex: -1,
  currentTrackPlaying: {},
  progressiveTrack: {},
  gridShow: false,
  user: null,
  isMobilePlayerActive: false,
}

const getters = {
  isPlaying: (state) => {
    return state.isPlaying
  },

  currentAlbum: (state) => {
    if (!state.list || state.listIndex < 0 || !state.list[state.listIndex]) {
      return null
    }

    if (state.list[state.listIndex].assoc_type) {
      return state.list[state.listIndex].assoc_type
    } else {
      return state.list[state.listIndex]
    }
  },
}

const actions = {
  setPlayingStatus({ commit }, isPlaying) {
    commit('setPlayingStatus', isPlaying)
  },

  setPauseStatus({ commit }, isPaused) {
    commit('setPauseStatus', isPaused)
  },

  setShuffleStatus({ commit }, isShuffle) {
    commit('setShuffleStatus', isShuffle)
  },

  setPlaylist({ commit }, list) {
    commit('setPlaylist', list)
  },

  setTracks({ commit }, tracks) {
    commit('setTracks', tracks)
  },

  setListIndex({ commit }, listIndex) {
    commit('setListIndex', listIndex)
  },

  updateFollowingStatus({ commit }, status) {
    commit('updateFollowingStatus', status)
  },

  setTrackIndex({ commit }, trackIndex) {
    // console.log('player action setTrackIndex', trackIndex)
    commit('setTrackIndex', trackIndex)
  },

  setCurrentPlayingTrack({ commit }, currentTrackPlaying) {
    console.log('current track', currentTrackPlaying)
    commit('setCurrentPlayingTrack', currentTrackPlaying)
  },

  setProgressiveTrack({ commit }, progressiveTrack) {
    commit('setProgressiveTrack', progressiveTrack)
  },

  setGridShow({ commit }, gridShow) {
    commit('setGridShow', gridShow)
  },

  setUpdatedUser({ commit }, user) {
    commit('setUpdatedUser', user)
  },

  toggleMobilePlayer({ commit }, status) {
    commit('toggleMobilePlayer', status)
  },
}

const mutations = {
  setPlayingStatus(state, isPlaying) {
    state.isPlaying = isPlaying
  },

  setPauseStatus(state, isPaused) {
    state.isPaused = isPaused
  },

  setShuffleStatus(state, isShuffle) {
    state.isShuffle = isShuffle
  },

  setPlaylist(state, list) {
    state.list = list
  },

  setTracks(state, tracks) {
    state.tracks = tracks
  },

  setListIndex(state, listIndex) {
    state.listIndex = listIndex
    // if (listIndex >= state.list.length) {
    //   state.listIndex = 0
    // } else {
    //   state.listIndex = listIndex
    // }
  },

  updateFollowingStatus(state, status) {
    if (state.list[state.listIndex]) {
      if (state.list[state.listIndex].assoc_type) {
        state.list[state.listIndex].assoc.publisher.is_following = status
      } else {
        state.list[state.listIndex].user.is_following = status
      }
    }
  },

  setTrackIndex(state, trackIndex) {
    state.trackIndex = trackIndex
    // if (trackIndex >= state.tracks.length) {
    //   state.trackIndex = 0
    // } else {
    //   state.trackIndex = trackIndex
    // }
  },

  setCurrentPlayingTrack(state, currentTrackPlaying) {
    state.currentTrackPlaying = currentTrackPlaying
  },

  setProgressiveTrack(state, progressiveTrack) {
    state.progressiveTrack = progressiveTrack
  },

  setGridShow(state, gridShow) {
    state.gridShow = gridShow
  },

  setUpdatedUser(state, user) {
    state.user = user
  },

  toggleMobilePlayer(state, status) {
    console.log('toggleMobilePlayer status', status);
    state.isMobilePlayerActive = status
  },
}

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/player.js